import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationAutomaticOntologyValuableConceptCreateRequest, ConfigurationAutomaticOntologyValuableConceptResponse } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'

class ValuableConceptRelationshipConfigurationServices {
    async getValuableConcepts(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAutomaticOntologyValuableConceptResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAutomaticOntologyValuableConceptResponse>>(`/configuration/laboratories/${laboratoryId}/automaticOntologyValuableConcepts`, filterModel, { params })
        return response.data
    }

    async getValuableConceptById(laboratoryId: number, automaticOntologyValuableConceptId: number): Promise<ConfigurationAutomaticOntologyValuableConceptResponse> {
        const response = await axios.get<ConfigurationAutomaticOntologyValuableConceptResponse>(`/configuration/laboratories/${laboratoryId}/automaticOntologyValuableConcepts/${automaticOntologyValuableConceptId}`)
        return response.data
    }

    async createValuableConcept(laboratoryId: number, request: ConfigurationAutomaticOntologyValuableConceptCreateRequest): Promise<ConfigurationAutomaticOntologyValuableConceptResponse> {
        const response = await axios.post<ConfigurationAutomaticOntologyValuableConceptResponse>(`/configuration/laboratories/${laboratoryId}/automaticOntologyValuableConcepts`, request)
        return response.data
    }

    async deleteValuableConcept(laboratoryId: number, automaticValuableConceptByOntologyIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticOntologyValuableConcepts/batch`, { data: automaticValuableConceptByOntologyIds })
        return response.data
    }
}

export const valuableConceptRelationshipConfigurationServices = new ValuableConceptRelationshipConfigurationServices()
